export enum Status {
  None,
  Delete,
  Create,
  Update,
}
